module.exports = __webpack_public_path__ + "img/questionmark.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/questionmark.png
// module id = 1265
// module chunks = 0